import React from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export const Modal = ({ isOpen, onClose, title, children, size = '2xl', noShadow = false }) => {
  const isFullScreen = size === 'full' || size === 'fullscreen';

  const maxWidthClass = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    'full': 'w-screen h-screen max-w-none rounded-none m-0 p-0',
    'fullscreen': 'w-screen h-screen max-w-none rounded-none m-0 p-0'
  }[size] || 'max-w-2xl';

  return (
    <AnimatePresence>
      {isOpen && (
        <div className={`fixed inset-0 z-[100] flex items-center justify-center ${isFullScreen ? 'p-0' : 'p-4 sm:p-6'}`} dir="rtl">
          {/* Backdrop */}
          <motion.div 
            className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={onClose}
          />
          
          {/* Modal Content */}
          <motion.div 
            className={`relative bg-white w-full ${maxWidthClass} ${isFullScreen ? 'rounded-none shadow-none flex flex-col h-screen' : `rounded-xl ${noShadow ? 'shadow-none' : 'shadow-2xl'}`}`}
            initial={{ opacity: 0, scale: isFullScreen ? 1 : 0.95, y: isFullScreen ? 0 : 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: isFullScreen ? 1 : 0.95, y: isFullScreen ? 0 : 20 }}
            transition={{ 
              type: 'spring', 
              damping: 25, 
              stiffness: 300,
              duration: 0.35 
            }}
          >
            <div className="flex items-center justify-between p-5 border-b border-slate-100 shrink-0">
              <h3 className="text-lg font-bold text-slate-800">{title}</h3>
              <motion.button 
                onClick={onClose}
                className="p-1.5 rounded-lg hover:bg-slate-100 text-slate-400 transition-colors"
                whileHover={{ rotate: 90 }}
                transition={{ duration: 0.2 }}
              >
                <X className="w-5 h-5" />
              </motion.button>
            </div>
            
            <div className={`p-5 overflow-y-auto ${isFullScreen ? 'flex-1 max-h-none' : 'max-h-[75vh]'}`}>
              {children}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
